import {
    Directive,
    ElementRef,
    HostListener,
    Input,
    Renderer2,
    OnDestroy
  } from '@angular/core';
  
  @Directive({
    selector: '[appToolTip]',
    standalone: true
  })
  export class ToolTipDirective implements OnDestroy {
    @Input('appToolTip') tooltipText = '';
    @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  
    private tooltip: HTMLElement | null = null;
  
    constructor(private el: ElementRef, private renderer: Renderer2) {}
  
    @HostListener('mouseenter')
    onMouseEnter() {
        if (
            !this.tooltip &&
            this.tooltipText !== undefined &&
            this.tooltipText !== null &&
            this.tooltipText !== ''
            ) {
            this.createTooltip();
        }
    }
  
    @HostListener('mouseleave')
    onMouseLeave() {
      this.destroyTooltip();
    }
  
    private createTooltip() {
      this.tooltip = this.renderer.createElement('span');
      this.tooltip.innerText = this.tooltipText;
      this.renderer.addClass(this.tooltip, 'app-tooltip');
      this.renderer.addClass(this.tooltip, `app-tooltip-${this.tooltipPosition}`);
  
      // Positioning
      const hostPos = this.el.nativeElement.getBoundingClientRect();
      document.body.appendChild(this.tooltip);
      const tooltipPos = this.tooltip.getBoundingClientRect();
  
      let top = 0, left = 0;
      switch (this.tooltipPosition) {
        case 'top':
          top = hostPos.top - tooltipPos.height - 8;
          left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
        case 'bottom':
          top = hostPos.bottom + 8;
          left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
        case 'left':
          top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
          left = hostPos.left - tooltipPos.width - 8;
          break;
        case 'right':
          top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
          left = hostPos.right + 8;
          break;
      }
  
      this.renderer.setStyle(this.tooltip, 'position', 'fixed');
      this.renderer.setStyle(this.tooltip, 'top', `${top}px`);
      this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
      this.renderer.setStyle(this.tooltip, 'z-index', '9999');
    }
  
    private destroyTooltip() {
      if (this.tooltip) {
        this.tooltip.remove();
        this.tooltip = null;
      }
    }
  
    ngOnDestroy() {
      this.destroyTooltip();
    }
  }